import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { changeCommission, changeCommissionPayee } from 'bundles/apex/deals/form/store/deal/actions';
import { updateTransactionSide } from 'bundles/backoffice/vouchers/helpers/commissions';

import BrokerGrossCommissionWrapper from 'bundles/apex/deals/form/fields/broker_gross_commission/wrapper';
import ContactSelector from 'bundles/backoffice/contacts/selector';
import ManagedInput from 'components/form/managed_input';
import Options from 'components/form/managed_input/options';

export function OutsideBroker({
  changeCommission,
  changeCommissionPayee,
  commission,
  deal,
  required,
  transactionSide,
  transactionSideOptions,
}) {
  const transactionSideOpts = transactionSideOptions && transactionSideOptions.map(([value, label]) => (
    { value: value, label: label }
  ));

  return (
    <BrokerGrossCommissionWrapper
      commission={commission}
      label="Outside Broker"
      required={required}
      transactionSide={transactionSide}
    >
      <ContactSelector
        className="flex-fill"
        contact={commission.contact}
        disabled={!!commission.id}
        onChange={contact => changeCommissionPayee(commission, { contact }, transactionSide)}
      />

      {transactionSideOpts && (
        <ManagedInput
          aria-label="transaction-side"
          className="transaction-side form-control"
          disabled={!!deal.voucher}
          includeBlank
          type="select"
          value={commission.transactionSide}
          onValueChange={(newSide) => {
            const changes = deal.hasTransactionSides
              ? updateTransactionSide(deal, commission, newSide)
              : { transactionSide: newSide };
            changeCommission(commission, changes);
          }}
        >
          <Options options={transactionSideOpts} />
        </ManagedInput>
      )}
    </BrokerGrossCommissionWrapper>
  );
}

OutsideBroker.propTypes = {
  changeCommission: PropTypes.func.isRequired,
  changeCommissionPayee: PropTypes.func.isRequired,
  commission: PropTypes.shape({
    contact: PropTypes.object,
    id: PropTypes.number,
    transactionSide: PropTypes.string,
  }).isRequired,
  deal: PropTypes.shape({
    hasTransactionSides: PropTypes.bool,
    voucher: PropTypes.object,
  }),
  primary: PropTypes.bool,
  required: PropTypes.bool,
  transactionSide: PropTypes.string,
  transactionSideOptions: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)),
};

const mapDispatchToProps = {
  changeCommission,
  changeCommissionPayee,
};

const mapStateToProps = state => ({
  deal: state.deal,
  transactionSideOptions: state.options.transactionSide,
});

export default connect(mapStateToProps, mapDispatchToProps)(OutsideBroker);
